import { DataGrid } from "@mui/x-data-grid";
import { opdReportColumns } from "./opReportsColumns";
import useOpdReportsHook from "./opdReportsHooks";

const OPDReports = () => {
    const { OpdReportsState, handleGetRowId } = useOpdReportsHook()
   
    return(
        <div className="opd-report-table p-5">
        <DataGrid
            autoHeight
            rows={OpdReportsState && OpdReportsState?.length > 0 ? OpdReportsState : []}
            loading={OpdReportsState?.length > 0 || OpdReportsState === null ? false : true}
            columns={opdReportColumns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            getRowId={handleGetRowId}
            checkboxSelection={false}
        />
    </div>
    )
};

export default OPDReports;